@use "../legend-layout" as *;

.controls-map-legend {
  color: var(--color-text-primary);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 8px 2px 2px;
  background-color: var(--color-bg-primary);
  box-sizing: border-box;
  height: $legend-controls-height;
  container-type: inline-size;

  & .parameter-text {
    font-size: 10cqw;
    flex: 1;
    max-width: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: default;
  }

  & span {
    font-size: 1rem;
    visibility: hidden;
  }
}

// show hide icon when hovering the legend (.map-legend-content is set on the legend container)
:global(.map-legend-content):hover .controls-map-legend span {
  visibility: visible;
  cursor: pointer;
  color: var(--color-icon-secondary);

  &:hover {
    color: var(--color-icon-brand);
  }
}
